import type { RendererProps } from '@atlaskit/renderer/core';
import { UNSUPPORTED_CONTENT_THRESHOLDS } from '@confluence/adf-renderer/entry-points/ADFRendererComponent.ts';
import { fg } from '@confluence/feature-gating';

export const unsupportedContentLevelsTrackingOptions =
	(): RendererProps['unsupportedContentLevelsTracking'] =>
		// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
		fg('platform_renderer_unsupported_content_tracking')
			? UNSUPPORTED_CONTENT_THRESHOLDS
			: undefined;
